import { Loader2 } from "lucide-react";
import { Navigate, Outlet } from "react-router";
import { AccountUnavailable } from "@/components/account-unavailable";
import { useMe } from "@/hooks/use-me.ts";
import { useSessionState } from "@/hooks/use-session-state.ts";

export function OnboardingRoute() {
	const status = useSessionState();
	const me = useMe();

	switch (status) {
		case "loading":
			return (
				<div className="route-loading">
					<Loader2 />
				</div>
			);
		case "orphan":
			return <AccountUnavailable />;
		case "ready":
			// Bounce out of the wizard only on positive evidence of an account: an
			// unreadable /me falls back to "ready" and must not eject the user.
			return me.data ? <Navigate to="/" replace /> : <Outlet />;
		default:
			return <Outlet />;
	}
}
